//  BASE URL
export const USER_BASE_URL = process.env.REACT_APP_USER_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const PAYMENT_BASE_URL = process.env.REACT_APP_PAYMENT_BASE_URL;
export const TRANSACTION_BASE_URL = process.env.REACT_APP_TRANSACTION_BASE_URL;
export const VENDOR_BASE_URL = process.env.REACT_APP_VENDOR_BASE_URL;

// Call back URL
export const CALLBACK_URL = process.env.REACT_APP_CALLBACK_URL;
// Call back URL

//Profile photo URL
export const UPLOAD_USER_PIC = USER_BASE_URL + "8090/v1/upload/asset";
export const UPDATE_USER_PIC = USER_BASE_URL + "v1/user/profile/image/update";

//Download URL
export const DOWNLOAD_COIN_INVOICE = TRANSACTION_BASE_URL + "v1/coin/invoice/";
export const DOWNLOAD_INVOICE = VENDOR_BASE_URL + "v1/download/pdf/";

export const GET_OTP = "customer/auth/v1/otp/get/";
export const RESEND_OTP = "customer/auth/v1/otp/resend/";
export const VERIFY_OTP = "customer/auth/v1/user/login";
export const GET_USER_API = "v1/user";
export const USER_INFO = "customer/workflow/user/info/details";
export const GET_USER_INFO = "customer/workflow/user/info/get";
export const UPDATE_USER_API = "customer/workflow/profile";
export const USER_REGISTER_API = "customer/workflow/new/create";
export const USER_PINCODE = "customer/workflow/v1/pincode";
export const VERIFY_PAN = "customer/workflow/pan";
export const VERIFY_IFSC = "customer/workflow/ifsc";
export const MF_INVESTER_CREATE = "customer/workflow/investor/create";
export const MF_INVESTMENT_CREATE = "customer/workflow/investment/create";
export const KYC_OTP = "customer/workflow/otp/get";
export const CREATE_KYC = "customer/workflow/kyc/create";
export const MF_DOCUMENTAPI = "customer/workflow/fileupload";
export const BANK_VERIFY_MF = "customer/workflow/bank";
export const KYC_DETAILS_VERIFY_MF = "customer/workflow/kyc/details";
export const GOLD_SILVER_LIVE_PRICES = "v1/gold/silver/rate";
export const MAIN_BALANCE_API = "v1/portfolio/";
export const GET_SELF_INVESTMENT = "v1/self/investment/history/";
export const ESIGN_MF = "customer/workflow/kyc/esign";
export const MF_KYC_STATUS = "customer/workflow/kyc/status/";
export const REDEEM_PRODUCTS_API = "v1/gold/silver/product?metalType=";
export const GET_GOLD_COINS = "v1/get/gold/coin";
export const ACTIVATE_MF = "customer/workflow/user/activate";
export const GET_ADDRESS = "v1/user/address?userId=";
//Gold Silver APIs
export const BUY_GOLD_COINS = "v1/purchase/gold/coin";
export const SELF_INVESTMENT_ORDER_API = "v1/self/investment/order";
export const REDEEM_ORDER_API = "v1/redeem/gold/silver/order";
export const GIFTING_API = "v1/paytm/initiate/transaction";
export const REDEEM_ORDER_STATUS_API = "v1/get/self/order/status";
export const GOLD_SILVER_TRANSACTION = "v2/all/investment/history";
export const MF_TRANSACTION = "customer/sip/investment/transaction";
export const GET_BANK_DETAILS = "v1/user/bank?userId=";
export const SELL_API = "v1/sell/gold/silver/order";
export const CREATE_BANK_ACCOUNT = "v1/user/bank";
export const GIFT_ORDER_STATUS = "v1/order/status";

//MutualFund APIs
export const MF_HOLDINGS = "customer/sip/investments/holdings";
export const MF_REDEEM = "customer/sip/redeem";
export const MF_PORTFOLIO_DATA = "customer/workflow/home/get";
export const MF_FUNDLIST = "customer/sip/fund/list";
export const MF_SCHEMS_URL = "customer/sip/schemes/fundcard";
export const MF_FUND_DEATILS = "customer/sip/fund/details/isin";
export const MF_ALL_HOLDINGS = "customer/sip/show/holdings/schemecode";
export const MF_GRAPH_NAV = "customer/sip/nav/history";
export const MF_ORDER = "customer/workflow/order/create/consent";
export const CREATE_LUMPSUM_MUTUAL_ORDER_FUND_URL = "v1/lumpsum/purchase";
export const MF_OTP_GENERATE = "customer/workflow/transaction/otp";
export const MF_OTP_VERIFY = "customer/workflow/transaction/otp/authenticate";
export const MF_SKIP_KYC = "customer/workflow/rekyc/skip";
export const MF_AMC_LIST = "customer/sip/sip/amc";

//Notification API
export const NOTIFICATIONS_API = "v1/get/notification?mobileNo=";
export const UPDATE_NOTIFICATIONS_API = "v1/update/badge?mobileNo=";

//userInfo
export const MF_USER_INFO = "customer/workflow/user/info/get";

//mandate SIP
export const MF_SIP_MANDATE = "v1/mf/create/mandate/web";
export const MF_SIP_STATUS = "v1/create/mf/sip/by/id/";
export const MF_SIP_API =
  "v1/fetch/mf/all/sip/plan?mf_investment_account=";
export const CANCEL_MF_SIP_URL = "v1/cancel/mf/sip/";
export const SKIP_MF_SIP_URL = "v1/skip/sip";

//nominee
export const GET_NOMINEES = "customer/workflow/nominee/list";
export const CREATE_NOMINEES = "customer/workflow/nominee/create";

//Support
export const GET_TICKETS = "support/ticket/user/get";
export const GET_TICKET_TAGS = "support/ticket/tags/get";
export const CREATE_SUPPORT_TICKETS = "support/new/ticket/create";

//Goal Ammount
export const GOAL_POT_URL = "v1/pot";
export const CREATE_FUNDING_RULES = "v1/pot/sip/funding/rules";
export const CREATE_GOLDFUNDING_RULES = "v1/pot/funding/rules";
export const GET_GOALS_LIST = "v1/pot/";
export const GS_POT_CHECK = "v1/get/pots/order/status";

//Goal cancel
export const GOAL_CANCEL_METEL = "v1/paytm/goal/subscription/cancel";
export const GOAL_CANCEL_MF = "v1/cancel/mf/goal/sip/";
export const SELL_API_GOALMETAL = "v1/paytm/sell/goal/subscription";

//NFO list
export const GET_NFO_LIST_URL = "v1/mf/nfo";
